var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "b-button-group",
        { staticClass: "d-flex" },
        [
          _c(
            "b-button",
            {
              staticClass: "text-left font-weight-normal",
              attrs: {
                block: "",
                id: "range-datepicker-trigger",
                variant: "light",
                disabled: _vm.disabled
              },
              on: { click: _vm.show }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.datePlaceholder) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "outline-input-special",
              attrs: { variant: "secondary", disabled: !_vm.isSelected },
              on: { click: _vm.reset }
            },
            [_c("i", { staticClass: "far fa-backspace" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "datepicker",
            width: 600,
            height: "auto",
            scrollable: true
          }
        },
        [
          _c("airbnb-style-datepicker", {
            attrs: {
              "trigger-element-id": "range-datepicker-trigger",
              mode: "range",
              "fullscreen-mobile": false,
              "date-one": _vm.range.start,
              "date-two": _vm.range.end,
              inline: true
            },
            on: {
              "date-one-selected": function(val) {
                _vm.range.start = val
              },
              "date-two-selected": function(val) {
                _vm.range.end = val
              },
              apply: _vm.apply,
              cancelled: _vm.cancelled
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }